<div class="box box--min-height u-p0" [class.u-ml--]="headerTitle && headerTitle === 'Destination'">
  <header *ngIf="showHeader" class="text-bold-16 box-header">{{ headerTitle }}</header>
  <div
    *ngIf="item; else noExams"
    class="
      patient-banner__container
      flex
      patient-banner__container--compressed patient-banner__container--collapsible patient-banner--dark
    "
  >
    <div class="patient-banner">
      <span class="patient-banner__name">{{ item.name }}</span>
    </div>
    <dl class="patient-banner__content flex flex--wrap u--1/1 patient-banner__content--compressed">
      <div class="patient-banner__data" aria-hidden="false">
        <dt class="patient-banner__value text-16">{{ 'label.pid' | translate }}</dt>
        <dd class="patient-banner__value--bold text-bold-16 patient-banner__mrn">
          <app-multi-domain-mrn [id]="item.id" [mrnData]="item.mrn" [showTooltip]="true"></app-multi-domain-mrn>
        </dd>
      </div>
      <div class="patient-banner__data" aria-hidden="false">
        <dt class="patient-banner__value text-16">{{ 'label.dob' | translate }}</dt>
        <dd class="patient-banner__value--bold text-bold-16 patient-banner__dob">
          {{ item.birthDate | dateTime: dateTimePref.dateFormat }}
        </dd>
      </div>
      <div class="patient-banner__data" aria-hidden="false">
        <dt class="patient-banner__value text-16">{{ 'label.gender' | translate }}</dt>
        <dd class="patient-banner__value--bold text-bold-16">{{ 'gender.' +item.gender | translate }}</dd>
      </div>
      <div class="patient-banner__data" aria-hidden="false">
        <dt class="patient-banner__value text-16">{{ 'label.age' | translate }}</dt>
        <dd class="patient-banner__value--bold text-bold-16">{{ patientAge }}</dd>
      </div>
    </dl>
  </div>
  <ng-template #noExams>
    <div
      class="
        patient-banner__container
        flex
        patient-banner__container--compressed patient-banner__container--collapsible patient-banner--dark
      "
    ></div>
  </ng-template>
  <div
    [ngStyle]="{ height: showHeader ? 'calc(100% - 12rem)' : 'calc(100% - 10rem)' }"
    class="exams_card_container"
    wfmScrollbar
  >
    <button class="card__button" *ngFor="let exam of exams; let i = index">
      <div class="card card__container card__container--stroke flex flex--col u-ml---" style="width: 32rem">
        <div class="card__content u-mt- u-mh- u-mb----">
          <div class="card__title-block u-pb--">
            <h2 class="heading-16 u-m0">{{ exam.workItem.procedureCode }}</h2>
            <h3 class="heading-14 u-m0">
              <span class="accession_no">{{ 'studyManagement.AccessionNumber' | translate }}</span>
              {{ exam.workItem.procedureAccessionNo }}
            </h3>
            <h3 class="heading-14 u-m0">
              {{ exam.workItem.procedureStartTime | dateTime: dateTimePref.dateTimeFormat }}
            </h3>
            <h3 class="heading-14 u-m0" *ngIf="exam.workItem.verifiedTimeOfExam != ''"> {{ 'status.Verified' | translate }}</h3>           
           
            <span class="card_image_cout">{{ exam.workItem.imageCount }}</span>
          </div>
        </div>
      </div>
    </button>
  </div>
</div>
